var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Calendar = function Calendar(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 3a1 1 0 1 0-2 0v1H9V3a1 1 0 0 0-2 0v1H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-1V3Zm2 7V7a1 1 0 0 0-1-1h-1v1a1 1 0 1 1-2 0V6H9v1a1 1 0 0 1-2 0V6H6a1 1 0 0 0-1 1v3h14ZM5 12h14v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7Zm5 2.696a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-2a1 1 0 0 1-1-1Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Calendar;